// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';
import type {TravelerData} from 'redux/v1/travelers/form/models';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_CUSTOMER_IS_TRAVELER =
  'v1/travelers/data/SET_CUSTOMER_IS_TRAVELER';
export const SUBMIT_TRAVELER_FORM = 'v1/travelers/data/SUBMIT_TRAVELER_FORM';
export const SET_TRAVELER_ERRORS = 'v1/travelers/data/SET_TRAVELER_ERRORS';
export const CREATE_TRAVELER_FORMS = 'v1/travelers/data/SET_TRAVELERS_COUNT';

export const setCustomerIsTraveler = (
  travelerIndex: ?number,
  nationality: ?string,
  journeyId: ?string,
  currentRoomIndex: ?number,
  checkedTravelerIndex: ?number
): PureAction => {
  return {
    type: PURE(SET_CUSTOMER_IS_TRAVELER),
    travelerIndex,
    nationality,
    journeyId,
    curRoomIndex: currentRoomIndex,
    checkedTravelerIndex,
  };
};

export const submitTravelerForm = (
  index: number,
  form: TravelerData
): PureAction => {
  return {
    type: PURE(SUBMIT_TRAVELER_FORM),
    index,
    form,
  };
};

export const setTravelerErrors = (
  index: number,
  errors: {[string]: string} | null = null
): PureAction => {
  return {
    type: PURE(SET_TRAVELER_ERRORS),
    index,
    errors,
  };
};

export const createTravelerForms = (count: number): PureAction => {
  return {
    type: PURE(CREATE_TRAVELER_FORMS),
    count,
  };
};
